import { useQuery } from "react-query";
import { GetPaymentMethodResponse } from "../../constants/types";
import axios from "../axios";
import qs from "query-string";

const handleRequest = async (totalBayar?: number) => {
    const apiPaymentMethod = qs.stringifyUrl({
        url: "/api/payment-methode/duitku",
        query: {
            totalBayar: totalBayar,
        },
    });
    const { data } = await axios.get<GetPaymentMethodResponse>(
        apiPaymentMethod,
    );
    return data.data;
};

export default function usePaymentMethod(totalBayar?: number) {
    return useQuery<GetPaymentMethodResponse["data"]>(
        ["listPaymentMethod", totalBayar],
        () => handleRequest(totalBayar),
    );
}
